import script from "./LivePhoto.vue?vue&type=script&setup=true&lang=ts"
export * from "./LivePhoto.vue?vue&type=script&setup=true&lang=ts"

import "./LivePhoto.vue?vue&type=style&index=0&id=25340bd8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25340bd8"]])

export default __exports__